<template>
  <div class="api-customer-view">
    <page-header :title="title">
      <template #actions>
        <icon-button
          icon="arrow_back"
          tooltip="Back to API Customers"
          @click="$router.push('/api-customers')"
        />
      </template>
    </page-header>

    <section v-if="loaded && customer">
      <p class="credential">
        {{ customer.credentialId }}
      </p>

      <p class="note">
        Daily call counts for the last 14 days, Central Time. Today includes calls so far.
      </p>

      <div class="table-container">
        <table class="usage-table">
          <thead>
            <tr>
              <th>Date</th>
              <th right>
                Calls
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="day in customer.days" :key="day.date">
              <td>
                {{ day.label }}
                <span v-if="day.partial" class="partial">so far</span>
              </td>
              <td right>
                {{ $filters.number(day.calls) }}
              </td>
            </tr>

            <tr class="total">
              <td>Total</td>
              <td right>
                {{ $filters.number(customer.total) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <empty-state
      v-else-if="loaded"
      icon="vpn_key"
      title="This API customer could not be loaded"
    />

    <spinner v-else />
  </div>
</template>

<script>
import firebase from 'firebase/compat/app';
import * as Sentry from '@sentry/vue';

export default {
  data() {
    return {
      loaded: false,
      customer: null,
    };
  },

  created() {
    this.load();
  },

  watch: {
    '$route.params.id'() {
      this.load();
    },
  },

  computed: {
    title() {
      if (this.customer && this.customer.displayName) {
        return this.customer.displayName;
      }

      return 'API Customer';
    },
  },

  methods: {
    async load() {
      this.loaded = false;
      this.customer = null;

      try {
        const { data } = await firebase.functions().httpsCallable('httpApiCustomerUsage')({
          uid: this.$route.params.id,
        });
        this.customer = data;
      } catch (e) {
        this.$toasted.error(e.message || 'Error loading API usage');
        Sentry.captureException(e);
        this.customer = null;
      }

      this.loaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.api-customer-view {
  @include container;
  min-height: 100%;
}

.credential,
.note {
  margin: 0 0 $gp;
}

.credential {
  font-family: monospace;
}

.note {
  color: var(--theme-secondary-color, #666);
}

.usage-table {
  max-width: 420px;
}

.partial {
  margin-left: $gp * .5;
  font-size: 12px;
  font-weight: normal;
  color: var(--theme-secondary-color, #666);
}

.total td {
  font-weight: bold;
}
</style>
